// v4: Request to revert draft to a previous version
export default class RevertContentDraftRequest {
  public version = 0;
}
